import { render, staticRenderFns } from "./RtxActionDeleteControl.vue?vue&type=template&id=99ba7dae"
import script from "./RtxActionDeleteControl.vue?vue&type=script&lang=js"
export * from "./RtxActionDeleteControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports